import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import language from './language/language.reducer';
import panel from './panel/panel.reducer';
import auth from './user/auth.reducer';

const rootReducer = combineReducers({
  auth,
  panel,
  language
});

const store = createStore(rootReducer, applyMiddleware(thunkMiddleware));

export default store;
